import { sagaListSuccess } from "../actions/ActionTypes";

const REPORT_SUMMARIES = "report_summaries";
const initialState = { summaries: [] };
export default function reports(state = initialState, action = {}) {
  switch (action.type) {
    case sagaListSuccess(REPORT_SUMMARIES):
      return { ...state, summaries: action.data };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reports.js